import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

type CreateViolationRequest = {
  raisedFor: number;
  type: string;
  severity: string;
  description: string;
  descriptionHtml: string;
  reportedTime: string; // ISO date-time string
};

export const createDisciplinaryAction = async (violation: CreateViolationRequest) => {
  try {
    const url = endpoints.disciplinaryActions.getDisciplinaryActions;

    const response = await sendRequest({
      url,
      method: 'POST',
      credentials: 'include',
      body: {
        ...violation,
      },
    });
    return response;
  } catch (err) {
    console.error('Error failed to create disciplinary action', err);
    throw err;
  }
};

export const searchEmployeeForViolation = async (searchText) => {
  try {
    const url = endpoints.disciplinaryActions.employeeSearchAutoComplete;
    const response = await sendRequest({
      url,
      method: 'GET',
      credentials: 'include',
      queryParams: { searchText },
    });
    return response;

    return response;
  } catch (err) {
    console.error('Error failed to fetch employees', err);
    throw err;
  }
};

export const getPastNotes = async (employeeId) => {
  try {
    const url = endpoints.disciplinaryActions.getPastNotes;
    const response = await sendRequest({
      url,
      method: 'GET',
      credentials: 'include',
      queryParams: { employeeId },
    });
    return response;
  } catch (err) {
    console.error('Error failed to fetch past notes', err);
    throw err;
  }
};
